module.exports = __webpack_public_path__ + "img/autonomy-extra-line.124ef271.svg";